import { getRect2Orientation } from "../../deck_start/DrawDeck";

export const getDeckType = ({ deckState }) => {
    return deckState.deckStructure.deckShape;
};

export const getDeckCutout = ({ cutouts, deckState }) => {
    const horizontal = false;
    const orientation = getRect2Orientation(deckState.deckStructure.deckRotation, horizontal);

    if (orientation === "right") {
        // Cutout front Right
        cutouts["FrontRight-CutoutType"] = "Step";
        cutouts["FrontRight-WidthX"] = Math.abs(deckState.deckStructure.widthB - deckState.deckStructure.widthA);
        cutouts["FrontRight-WidthY"] = Math.abs(deckState.deckStructure.lengthA);
    } else if (orientation === "bottom") {
        // Cutout back Right
        cutouts["FrontLeft-CutoutType"] = "Step";
        cutouts["FrontLeft-WidthX"] = Math.abs(deckState.deckStructure.lengthA);
        cutouts["FrontLeft-WidthY"] = Math.abs(deckState.deckStructure.widthB - deckState.deckStructure.widthA);
    } else if (orientation === "left") {
        // Cutout back Left
        cutouts["BackLeft-CutoutType"] = "Step";
        cutouts["BackLeft-WidthX"] = Math.abs(deckState.deckStructure.widthB - deckState.deckStructure.widthA);
        cutouts["BackLeft-WidthY"] = Math.abs(deckState.deckStructure.lengthA);
    } else if (orientation === "top") {
        // Cutout front Left
        cutouts["BackRight-CutoutType"] = "Step";
        cutouts["BackRight-WidthX"] = Math.abs(deckState.deckStructure.lengthA);
        cutouts["BackRight-WidthY"] = Math.abs(deckState.deckStructure.widthB - deckState.deckStructure.widthA);
    }

    return cutouts;
};

export const getDeckWidth = ({ deckType, deckState, fixedState }) => {
    const horizontal = false;
    const orientation = getRect2Orientation(deckState.deckStructure.deckRotation, horizontal);

    if (deckType === fixedState.deckStructure.deckShape[0]) {
        if (orientation === "right" || orientation === "left") return deckState.deckStructure.widthA;
        return deckState.deckStructure.lengthA;
    } else if (deckType === fixedState.deckStructure.deckShape[1]) {
        if (orientation === "right" || orientation === "left") return deckState.deckStructure.widthB;
        return deckState.deckStructure.lengthB + deckState.deckStructure.lengthA;
    }
};

export const getDeckHeight = ({ deckType, deckState, fixedState }) => {
    const horizontal = false;
    const orientation = getRect2Orientation(deckState.deckStructure.deckRotation, horizontal);
    if (deckType === fixedState.deckStructure.deckShape[0]) {
        if (orientation === "right" || orientation === "left") return deckState.deckStructure.lengthA;
        return deckState.deckStructure.widthA;
    } else if (deckType === fixedState.deckStructure.deckShape[1]) {
        if (orientation === "right" || orientation === "left")
            return deckState.deckStructure.lengthB + deckState.deckStructure.lengthA;

        return deckState.deckStructure.widthB;
    }
};

export const updateAttachments = (rect, updateNewJobState, disabledCases = [], horizontal = false) => {
    Object.keys(rect).forEach((attachment) => {
        let hoz_attachment = attachment;
        if (horizontal) {
            // Flipped clockwise 90*
            // eslint-disable-next-line default-case
            switch (attachment) {
                case "left":
                    hoz_attachment = "top";
                    break;
                case "top":
                    hoz_attachment = "right";
                    break;
                case "right":
                    hoz_attachment = "bottom";
                    break;
                case "bottom":
                    hoz_attachment = "left";
                    break;
            }
        }

        if (disabledCases.includes(hoz_attachment)) {
            return; // Skip disabled cases
        }

        switch (hoz_attachment) {
            case "left":
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS["AttachmentBottom"] =
                    rect[attachment] === true ? 1 : 0;

                break;
            case "top":
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS["AttachmentLeft"] =
                    rect[attachment] === true ? 1 : 0;

                break;
            case "right":
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS["AttachmentTop"] =
                    rect[attachment] === true ? 1 : 0;

                break;
            case "bottom":
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS["AttachmentRight"] =
                    rect[attachment] === true ? 1 : 0;

                break;
            default:
                break;
        }
    });
};
